<template>
  <div class="mb-5">
    <v-layout row wrap mx-4>
      <v-flex md12>
        <v-layout row wrap>
          <v-flex md3>
            <p class="headline pt-2">
              Call center
            </p>
          </v-flex>
          <v-flex md2 pr-3 mb-2>
            <v-btn block class="h-100 ma-0" @click="generateReport">
              <v-icon small>fas fa-download</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md3 pr-3>
            <v-select
              :items="channels"
              v-model="filters.channel"
              label="Canal"
              solo
              color="grey"
            ></v-select>
          </v-flex>
          <v-flex md2 pr-3>
            <v-select
              :items="typeFilters"
              v-model="filters.dateType"
              label="Tipo de fecha"
              solo
              color="grey"
            ></v-select>
          </v-flex>
          <v-flex md2>
            <v-menu
              ref="from"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="filters.date"
              transition="scale-transition"
              min-width="290px"
              lazy
              offset-y
              full-width>
                <v-text-field
                  slot="activator"
                  v-model="formatedDate"
                  class="k-orange-linear-text"
                  prepend-icon="event"
                  label="Periodo"
                  readonly
                  solo>
                </v-text-field>
                <v-date-picker
                  v-model="filters.date"
                  @input="$refs.from.save(filters.date)"
                  locale="es"
                  :type="filters.dateType"
                  color="k-orange-linear">
                </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <v-data-table
              :headers="headers"
              :items="users"
              hide-actions
              no-data-text="No se encontraron registros"
              class="mt-3 bordered elevation-2"
            >
              <template slot="headerCell" slot-scope="props" class="k-orange-linear">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.descrip }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-icon class="pr-2 pb-1 k-orange-linear-text" small>fas fa-user</v-icon>
                  {{props.item.first_name.toUpperCase()}} {{props.item.last_name.toUpperCase()}}
                </td>
                <td class="text-xs-center">
                  {{props.item.customers}}
                </td>
                <td class="text-xs-center">
                  {{props.item.contacted}}
                </td>
                <td class="text-xs-center">
                  {{props.item.payment_promise}}
                </td>
                <td class="text-xs-center">
                  {{props.item.effective_payment}}
                </td>
              </template>
              <template slot="footer" v-if="users.length > 0">
                <td>
                  <strong>Total</strong>
                </td>
                <td class="text-xs-center">
                  <strong>{{sumQty.calls}}</strong>
                </td>
                <td class="text-xs-center">
                  <strong>{{sumQty.contacted}}</strong>
                </td>
                <td class="text-xs-center">
                  <strong>{{sumQty.promise}}</strong>
                </td>
                <td class="text-xs-center">
                  <strong>{{sumQty.recive}}</strong>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import channelsMixins from '@/mixins/channels';

export default {
  mixins: [
    channelsMixins,
  ],
  data() {
    return {
      users: [],
      token1: this.axios.CancelToken.source(),
      headers: [
        {
          text: 'Agentes',
          align: 'left',
          sortable: false,
          value: 'first_name  ',
          descrip: 'Agentes que han gestionado correspondiente a la fecha',
        },
        {
          text: 'Llamadas realizadas',
          align: 'center',
          value: 'customers',
          descrip: 'Cantidad de clientes que llamo el agente',
        },
        {
          text: 'Llamadas contactadas',
          align: 'center',
          value: 'contacted',
          descrip: 'Cantidad de clientes que contacto el agente',
        },
        {
          text: 'Compromisos de pago',
          align: 'center',
          value: 'payment_promise',
          descrip: 'Cantidad de compromisos de pago que realizo el agente',
        },
        {
          text: 'Pagos recibidos',
          align: 'center',
          value: 'effective_payment',
          descrip: 'Cantidad de pagos recibidos',
        },
      ],
      filters: {
        type: 1,
        dateType: 'date',
        channel: 5,
        date: moment().format('YYYY-MM-DD'),
      },
      typeFilters: [
        {
          text: 'Mensual',
          value: 'month',
        },
        {
          text: 'Diario',
          value: 'date',
        },
      ],
    };
  },
  mounted() {
    this.getUserMetrics();
  },
  computed: {
    channels() {
      return this.allChannels.filter(x => x.channel.includes('human'))
      // eslint-disable-next-line
        .map((x) => {
          return {
            text: this.showNameChannel(x.id),
            value: x.id,
          };
        });
    },
    sumQty() {
      const obj = {
        calls: 0,
        contacted: 0,
        promise: 0,
        recive: 0,
      };
      for (let i = 0; i < this.users.length; i += 1) {
        obj.calls += this.users[i].customers;
        obj.contacted += this.users[i].contacted;
        obj.promise += this.users[i].payment_promise;
        obj.recive += this.users[i].effective_payment;
      }
      return obj;
    },
    formatedDate() {
      const typeFormat = this.filters.dateType === 'month' ? 'MM/YYYY' : 'DD/MM/YYYY';
      return moment(this.filters.date, 'YYYY-MM-DD').format(typeFormat);
    },
    ...mapGetters({
      allChannels: 'channels',
    }),
  },
  methods: {
    cancelRequest(token) {
      this[token].cancel('');
      this[token] = this.axios.CancelToken.source();
    },
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: this.filters,
          functionName: 'managementTotal',
        },
      });
    },
    getUserMetrics() {
      this.cancelRequest('token1');
      this.axios.get('/notification_schedules/user_metrics', {
        cancelToken: this.token1.token,
        params: {
          ...this.filters,
        },
      }).then((response) => {
        this.users = response.data;
      }).catch(() => {});
    },
  },
  watch: {
    filters: {
      handler() {
        this.getUserMetrics();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/call_center/Callers.vue